import React from 'react'
import styles from "./styles.module.css";

const ToggleNavbar = ({ children, toggle }) => {
  return (
    <div className={`${styles.navbar} ${toggle && styles.toggle}`}>
      <div className={styles.padding}>
        {children}
      </div>
    </div>
  )
}

export default ToggleNavbar;